import * as z from "zod";

export const TranslatableMoneyParamSchema = z.object({
  type: z.literal("money"),
  amount: z.number(),
  currency: z.string(),
});

export type TranslatableMoneyParam = z.infer<
  typeof TranslatableMoneyParamSchema
>;

export const TranslatableParamSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
  TranslatableMoneyParamSchema,
]);

export type TranslatableParam = z.infer<typeof TranslatableParamSchema>;

/**
 * Text stored now and translated when it is read. `key` is a backend catalog
 * template; `params` keep raw values so they can be formatted per locale.
 */
export const TranslatableTextSchema = z.object({
  key: z.string(),
  params: z.record(z.string(), TranslatableParamSchema).nullish(),
});

export type TranslatableText = z.infer<typeof TranslatableTextSchema>;
